// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ZW_t1"};